import { LocalizedMessagesBundle } from '../shared/models/i18n.model';

export const langxObj: LocalizedMessagesBundle = {
  'zh-cn': {
    'LOADING_TEXT': '加载中...'
  },
  'en-gb': {
    'LOADING_TEXT': 'Loading...'
  }
}